/**
 *
 * @type {Class}
 */
export default class SortingDisplay {

  constructor(el) {

    this.el = el;
    this.trigger = [].slice.call(this.el.querySelectorAll('.tc-sorting-display-el'));

    this.registerEvents();
  }

  registerEvents() {

    this.trigger.map(el => {

      el.addEventListener('click', this.onChangeSortingDisplay.bind(this), false);

      return el;
    });

  }

  onChangeSortingDisplay(e) {

    // e.preventDefault();

    this.trigger.map(el => {

      if (el === e.currentTarget) {

        el.classList.add('active');
      } else {

        el.classList.remove('active');
      }

      return el;
    });
  }
};
